import { Employee } from '../../pages/arc/features/employment/employment-model';

export function getFormattedName(employee: Employee) {
    if (!employee) {
        return '';
    }

    const { first_name, middle_name, last_name, suffix } = employee;

    const leftSegment = suffix ? `${last_name} ${suffix}` : last_name;
    const rightSegment = middle_name ? `${first_name} ${middle_name}` : first_name;

    return `${leftSegment}, ${rightSegment}`;
}

export function calculateAge(birthDate: string): number {
    const splitBirthDate = birthDate.split('/');
    const year = parseInt(splitBirthDate[2], 10);
    const month = parseInt(splitBirthDate[0], 10) - 1; // Months are zero-indexed
    const day = parseInt(splitBirthDate[1], 10);

    const formatBirthDate = new Date(year, month, day);
    const today = new Date();
    const birthYear = formatBirthDate.getFullYear();
    const currentYear = today.getFullYear();
    let age = currentYear - birthYear;

    const birthMonth = formatBirthDate.getMonth();
    const currentMonth = today.getMonth();
    if (currentMonth < birthMonth || (currentMonth === birthMonth && today.getDate() < formatBirthDate.getDate())) {
        age -= 1;
    }

    return age;
}